<template>
  <div>
    <div class="mb-6">
      <p class="font-medium text-base mb-2">
        {{ title }}
      </p>
      <div v-html="legendsHtml" ref="legendsRef"></div>
    </div>
    <config-bar-chart
      :chart-data="chartData"
      @generate-legend-bar-chart="generateLegends"
      :ticks-config="ticksConfig"
      ref="barChart"
    ></config-bar-chart>
  </div>
</template>
<script>
import ConfigBarChart from "./ConfigBarChart";
export default {
  components: { ConfigBarChart },
  props: ["chartData", "title", "ticksConfig"],
  data() {
    return {
      legendsHtml: ""
    };
  },
  methods: {
    generateLegends(legend) {
      this.legendsHtml = legend;
    }
  }
};
</script>
